export default __webpack_public_path__ + "static/media/ce_notes_bribery.928b24df.png";